<script setup lang="ts">
import { ref } from 'vue'
import { debounce } from 'lodash'
import { getPlaces } from '../../../core/requests/Address'

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  onlyaddress: {
    type: Boolean,
    default: false,
  },
  nomaps: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['selected'])

const input = ref('')
const showPlaces = ref(false)
const places: any = ref([])

const onchange = debounce(async () => {
  if (!props.nomaps) {
    showPlaces.value = false
    places.value = []
    const _places: any = await getPlaces({
      q: input.value,
      gl: 'pe',
      hl: 'en',
      num: 20,
      autocorrect: true,
      page: 1,
      type: 'maps',
    })

    places.value = _places.places
    showPlaces.value = true
  } else {
    emit('selected', {
      // position: item,
      label: input.value,
    })
  }
}, 500)

const checkPlaces = () => {
  showPlaces.value = places.value.length
}

const selectPlace = (item: any) => {
  showPlaces.value = false
  if (props.onlyaddress && !item.address) {
    input.value = `${item.title}`
  } else {
    input.value = `${item.title} ${item.address ? '- ' + item.address : ''}`
  }
  emit('selected', {
    position: item,
    label: input.value,
  })
}
</script>

<template>
  <div class="">
    <div class="relative">
      <VaInput
        v-model="input"
        :label="$props.label"
        placeholder="Escribe la dirección"
        @input="onchange()"
        @click="checkPlaces"
      />

      <div
        v-if="showPlaces"
        class="i-filter-results bg-white w-full shadow bg-blue-100"
        @mouseleave="showPlaces = false"
      >
        <p
          v-for="(item, index) in places"
          :key="index"
          class="text-xs hover:bg-primary hover:text-white cursor-pointer"
          @click="selectPlace(item)"
        >
          {{ item.title }} {{ item.address && '- ' + item.address }}
        </p>
      </div>
    </div>
  </div>
</template>

<style>
.i-filter-results {
  position: absolute;
  top: 46px;
  left: 0;
  max-height: 70px;
  overflow-y: scroll;
  padding: 5px 6px;
  z-index: 9;
}
</style>
